module.exports = __webpack_public_path__ + "img/icon-energy-washing.41b8f0e7.svg";